// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Vaor","tab":"ProcedureTabs_tab__2d76h"};